module.exports = {
  siteTitle: 'Jem Tucker | Software Engineer',
  siteDescription:
    '',
  siteKeywords:
    '',
  siteUrl: 'https://jemtucker.com',
  siteLanguage: 'en_UK',
  name: 'Jem Tucker',
  location: 'Cornwall, United Kingdom',
  email: 'jem.tucker@gmail.com',
  github: 'https://github.com/',
  twitterHandle: '@jemtckr',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/jemtucker',
    },
    {
      name: 'GitLab',
      url: 'https://gitlab.com/jem.tucker',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/jem-tucker/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Blog',
      url: '/#blog',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#36c8ff',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
